import { render, staticRenderFns } from "./WebglViewer.vue?vue&type=template&id=02845c60&scoped=true"
import script from "./WebglViewer.vue?vue&type=script&lang=js"
export * from "./WebglViewer.vue?vue&type=script&lang=js"
import style0 from "./WebglViewer.vue?vue&type=style&index=0&id=02845c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02845c60",
  null
  
)

export default component.exports